import { render, staticRenderFns } from "./ObservacionesPagos.vue?vue&type=template&id=2c33170d&"
import script from "./ObservacionesPagos.vue?vue&type=script&lang=js&"
export * from "./ObservacionesPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports